import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components';
import { useNavigation, useSearchValidation } from 'hooks';
import { useSearchQuery } from 'state';
import styles from './MainHeaderSearch.module.scss';

export default function MainHeaderSearch() {
    const [query, setQuery] = useSearchQuery();
    const [value, setValue] = useState<string>(query);
    const [submitted, setSubmitted] = useState(false);

    const { isValid, errorMessage } = useSearchValidation(value);

    const location = useLocation();
    const { navigateToSearch, searchUrl } = useNavigation();

    const onChange = (e: InputChangeEvent) => {
        setValue(e.value);
        if (submitted) setSubmitted(false);
    };

    const onSubmit = () => {
        setSubmitted(true);
        if (!isValid) return;
        setQuery(value.trim());
        if (location.pathname !== searchUrl) {
            navigateToSearch();
        }
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            onSubmit();
        }
    };

    const showError = (submitted || value?.length > 0) && errorMessage;

    return (
        <>
            <div className={styles.searchBarContainer}>
                <Input
                    type="search"
                    autoFocus={true}
                    className={styles.searchInput}
                    aria-label="search"
                    placeholder="Enter Payment, Invoice, or Dispute #"
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    validationMessage={showError ? errorMessage : undefined}
                />
                <Button
                    iconDefinition={faMagnifyingGlass}
                    onClick={onSubmit}
                    className={styles.searchButton}
                />
            </div>
            {showError && <div className={styles.searchError}>{errorMessage}</div>}
        </>
    );
}
